<template>
  <v-radio :label="label" :value="value" :class="radioClass" />
</template>

<script>
import { RADIO_INPUT_TYPES } from '../../../consts'

// TODO: Think about whether or not we need a v-model on this cmp, probably not because it's gonna be used with RadioGroup in 99% of cases
export default {
  name: 'RadioInput',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: RADIO_INPUT_TYPES,
      required: true
    },
    asBtn: {
      type: Boolean
    }
  },
  computed: {
    radioClass () {
      return {
        'as-btn': this.asBtn
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/setup/media-queries';
@import '../../../styles/setup/color-pallete';

.v-radio {
  gap: 5px;

  &.as-btn {
    gap: 0;
    width: 100%;

    &.v-item--active {
      label {
        color: $clr-text-bw08;
        border: 1px solid $clr-actionA3;
        background-color: $clr-action00;
      }
    }

    label {
      justify-content: center;
      width: 100%;
      padding: 12px;
      // margin-top: 0 !important;
      // height: 54px;
      border-radius: 6px;
      border: 1px solid $clr-text-bw03;
      font-family: MetricRRegular;
      font-size: 16px;
      color: $clr-text-bw07;
      background-color: white;
      transition: background-color 0.5s ease;
    }

    .v-input--selection-controls__input,
    .v-input--selection-controls__ripple,
    .v-input--selection-controls__ripple::before,
    input {
      display: none;
    }
    @media (min-width: $bp2) {
      width: 327px;
      label {
        padding: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/globalUiComponents/radio/RadioInput.vue